import React from 'react';
import ReactDOM from 'react-dom/client';
import MainRouter from './MainRouter';
import './Styles.css'; // Importar el archivo CSS global
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter} from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <BrowserRouter>
<MainRouter/> 
      </BrowserRouter>
            

      
);